import { atom } from 'jotai';

// Atom to store only the access object from localStorage scope
export const scopeListAccessAtom = atom(() => {
  const scopeItem = localStorage.getItem('scope');
  if (scopeItem) {
    try {
      const parsed = JSON.parse(scopeItem);
      return parsed.access || {};
    } catch {
      return {};
    }
  }
  return {};
});
